import { render, staticRenderFns } from "./CategorySelectComponent.vue?vue&type=template&id=31558f34&"
import script from "./CategorySelectComponent.vue?vue&type=script&lang=js&"
export * from "./CategorySelectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports